export default __webpack_public_path__ + "static/media/Woman_in_orange_with_young_girl.14ec6c81.jpg";